import { RevealLines } from "@/components/RevealText";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { EnquiryForm } from "@/components/EnquiryForm";
import { FAQS } from "@/data/faq";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => (
  <div data-testid="faq-page">
    <section className="pt-40 pb-16 border-b border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <Breadcrumbs items={[{ label: "FAQ", to: "/faq" }]} />
        <div className="mt-10 flex items-center gap-4">
          <div className="h-px w-12 bg-edge" />
          <span className="text-[10px] tracking-[0.35em] text-edge uppercase font-bold">
            Frequently Asked
          </span>
        </div>
        <RevealLines
          as="h1"
          lines={[
            "The questions",
            <>
              we get <span className="text-edge">every week</span>.
            </>,
          ]}
          className="mt-8 font-display font-black uppercase tracking-tighter text-[12vw] md:text-[9vw] lg:text-[6.5vw] leading-[0.9]"
        />
      </div>
    </section>

    <section className="py-16 border-b border-white/10">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <Accordion type="single" collapsible>
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-q-${i}`}
                className="text-left font-display uppercase text-lg md:text-2xl tracking-tight py-6 hover:text-edge"
              >
                <div className="flex items-start gap-6">
                  <span className="font-editorial italic text-edge text-lg md:text-2xl">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{f.q}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-white/75 pb-6 pl-16 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>

    <section className="py-24 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <h2 className="font-display uppercase text-4xl md:text-5xl font-black tracking-tighter leading-[0.95]">
            Didn't find your answer?
          </h2>
          <p className="mt-6 text-white/70">
            Send it to us — we'll answer personally and add it to this page.
          </p>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 border border-white/10 bg-ink-900/50 p-8 lg:p-10">
          <EnquiryForm variant="compact" source="faq-page" />
        </div>
      </div>
    </section>
  </div>
);

export default FAQ;
